import { render } from "./RevenueCard.vue?vue&type=template&id=64224230&scoped=true"
import script from "./RevenueCard.vue?vue&type=script&lang=js"
export * from "./RevenueCard.vue?vue&type=script&lang=js"

import "./RevenueCard.vue?vue&type=style&index=0&id=64224230&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64224230"]])

export default __exports__